// extracted by mini-css-extract-plugin
module.exports = {"btn":"EditStatus_btn_1_Xzs","forminput":"EditStatus_forminput_38Nxg","numberinput":"EditStatus_numberinput_1L06h"};